import { X_TENANT } from "core/types/api.constants";

import { IMiddleware, InternalAxiosRequestConfig } from "@bps/http-client";
import { getActiveAccount } from "@bps/msal";

/**
 * Returns a request interceptor that will add an X-Tenant HTTP header
 * with either the value of tenant if provided or will default to the
 * value of the hostname
 */
export class TenantInterceptorMiddleware
  implements IMiddleware<InternalAxiosRequestConfig>
{
  onFulfilled = async (
    config: InternalAxiosRequestConfig
  ): Promise<InternalAxiosRequestConfig> => {
    const accountInfo = await getActiveAccount();
    const tenantId = accountInfo?.tenantId;

    if (tenantId) {
      config.headers[X_TENANT] = tenantId;
    }

    return config;
  };
}
